module.exports = __webpack_public_path__ + "img/vr.001a2b45.svg";